import { ChangeDetectionStrategy, Component, computed, inject, OnInit, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { CheckboxComponent, TooltipModule } from '@libs/ui-lib';
import { TranslatePipe } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { VideoPlayerComponent } from '@libs/video-player';
import { PerioExamTutorialService, stepOrderRecord, TutorialStep, TutorialStepContent } from './perio-exam-tutorial.service';

@Component({
  selector: 'lib-perio-exam-tutorial',
  imports: [CommonModule, SvgIconComponent, CheckboxComponent, TranslatePipe, ReactiveFormsModule, TooltipModule, VideoPlayerComponent],
  templateUrl: './perio-exam-tutorial.component.html',
  styleUrl: './perio-exam-tutorial.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioExamTutorialComponent implements OnInit {
  private readonly perioExamTutorialService = inject(PerioExamTutorialService);

  protected readonly steps = [TutorialStep.ExamOrder, TutorialStep.TeethProgression, TutorialStep.VoiceControls, TutorialStep.InputMode];
  protected readonly stepOrderRecord: Record<TutorialStep, TutorialStepContent> = stepOrderRecord;
  protected readonly handleClose = output<void>();
  protected readonly activeStep = computed(() => this.perioExamTutorialService.viewModel().activeStep);
  protected readonly isFirstStep = computed(() => this.perioExamTutorialService.viewModel().firstStep);
  protected readonly isLastStep = computed(() => this.perioExamTutorialService.viewModel().lastStep);
  protected readonly dontShowAgain = computed(() => this.perioExamTutorialService.viewModel().hidePerioExamTutorial);

  public ngOnInit(): void {
    this.perioExamTutorialService.init();
  }

  protected goToStep(step: TutorialStep): void {
    this.perioExamTutorialService.setActiveStep(step);
  }

  protected goToNextStep(): void {
    const currentStep = this.perioExamTutorialService.viewModel().activeStep;
    const currentIndex = this.steps.indexOf(currentStep);
    if (currentIndex < this.steps.length - 1) {
      const nextStep = this.steps[currentIndex + 1];
      this.perioExamTutorialService.setActiveStep(nextStep);
    }
  }

  protected goToPreviousStep(): void {
    const currentStep = this.perioExamTutorialService.viewModel().activeStep;
    const currentIndex = this.steps.indexOf(currentStep);
    if (currentIndex > 0) {
      const previousStep = this.steps[currentIndex - 1];
      this.perioExamTutorialService.setActiveStep(previousStep);
    }
  }

  protected setDontShowAgain(): void {
    this.perioExamTutorialService.setHidePerioExamTutorial(!this.dontShowAgain());
  }

  protected closeTutorial(): void {
    this.handleClose.emit();
  }
}
